import React, { useState } from 'react';
import clsx from 'clsx';

import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import Link from '@common/Link';
import Button from '@common/Button';

import linkedin from '@images/socials/linkedIn.svg';
import share from '@images/socials/share.svg';
import twitter from '@images/socials/x.svg';
import facebook from '@images/socials/facebook.svg';

const Socials = ({ location, addClass }) => {
  const url = location?.href || 'https://lillio.com/blog';
  const copyUrl = () => {
    navigator.clipboard.writeText(url);
    toggleShow();
  }
  const [show, setShow] = useState(false);
  const toggleShow = () => setShow(!show);
  return (
    <div className='position-relative'>
      <div className={clsx('d-flex', addClass)}>
        <Button onClick={copyUrl} addClass='p-0 scale-1' style={{marginRight: '10px'}}>
          <img src={share} alt='' height={30} width={30}/>
        </Button>
        <Link to={`https://www.facebook.com/sharer/sharer.php?u=${url}`} className='scale-1' style={{marginRight: '10px'}}>
          <img src={facebook} alt='' height={30} width={30}/>
        </Link>
        <Link to={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`} className='scale-1' style={{marginRight: '10px'}}>
          <img src={linkedin} alt='' height={30} width={30}/>
        </Link>
        <Link to={`https://twitter.com/intent/tweet?url=${url}`} className='scale-1' style={{marginRight: '10px'}}>
          <img src={twitter} alt='' height={30} width={30}/>
        </Link>
      </div>
      <ToastContainer>
        <Toast show={show} onClose={() => toggleShow()}>
          <Toast.Header className='justify-content-between'>{'Copied to Clipboard'}</Toast.Header>
        </Toast>
      </ToastContainer>
    </div>
  )
}

export default Socials
